import { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import "./contactmodal.css";

const ContactModal = ({ isOpen, onClose, prefilledService, prefilledPackage }) => {
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [service, setService] = useState(prefilledService || "Site vitrine");
  const [packageLabel, setPackageLabel] = useState(prefilledPackage || "");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const servicesData = [
    {
      id: "vitrine",
      title: "Site vitrine",
      prices: [
        { label: "Essentiel", price: "À partir de 1599€" },
        { label: "Avancé", price: "À partir de 1999€" },
      ],
    },
    {
      id: "ecommerce",
      title: "E-commerce",
      prices: [
        { label: "Pack boutique", price: "À partir de 2499€" },
      ],
    },
    {
      id: "application",
      title: "Application sur mesure",
      prices: [
        { label: "Projet sur-mesure", price: "À partir de 2999€" },
      ],
    },
  ];

  const currentServiceData = servicesData.find(s => s.title === service);

  useEffect(() => {
    if (!isOpen) return;
    if (prefilledService) setService(prefilledService);
    if (prefilledPackage) setPackageLabel(prefilledPackage);

    const onEsc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [isOpen, prefilledService, prefilledPackage, onClose]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!contact.trim()) {
      alert("Merci de renseigner au moins votre email ou téléphone !");
      return;
    }

    setSending(true);

    emailjs.send(
      "service_0r2vblk",
      "template_9d0jkc2",
      {
        name: name || "Anonyme",
        contact_info: contact,
        service_type: service,
        package_selected: packageLabel,
        message_content: message,
        time: new Date().toLocaleString(),
      },
      "uM44s8MO4NSpPNswT"
    )
      .then(() => {
        alert("Message envoyé avec succès !");
        setName("");
        setContact("");
        setService(prefilledService || "Site vitrine");
        setPackageLabel(prefilledPackage || "");
        setMessage("");
        onClose();
      })
      .catch((error) => {
        console.error(error);
        alert("Une erreur est survenue, veuillez réessayer.");
      })
      .finally(() => setSending(false));
  };

  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Fermer">✕</button>

        <div className="modal-grid">
          {/* COLONNE GAUCHE */}
          <div className="modal-left">
            <h2 className="modal-title">Démarrer un projet</h2>
            <p className="modal-desc">
              Parlez-moi brièvement de votre besoin, je vous répondrai rapidement avec une proposition adaptée.
            </p>

            <div className="form-row name-contact">
              <div>
                <label className="form-label">Votre nom</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="modal-input"
                  placeholder="Votre nom"
                />
              </div>

              <div>
                <label className="form-label">Email/Téléphone <span style={{ color: "red" }}>*</span></label>
                <input
                  type="text"
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                  className="modal-input"
                  placeholder="Votre email ou téléphone"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <label id="radiotitle" className="form-label">Type de service</label>
              <div className="modal-select-group">
                {servicesData.map((s) => (
                  <label key={s.title} className="radio-label">
                    <input
                      type="radio"
                      name="service"
                      value={s.title}
                      checked={service === s.title}
                      onChange={(e) => { setService(e.target.value); setPackageLabel(""); }}
                    />
                    <span></span>
                    {s.title}
                  </label>
                ))}
              </div>

            </div>

            {currentServiceData && currentServiceData.prices.length > 0 && (
              <div className="form-row">
                <label className="form-label">Package</label>
                <select
                  value={packageLabel}
                  onChange={(e) => setPackageLabel(e.target.value)}
                  className="modal-input"
                >
                  <option value="">Sélectionnez un package</option>
                  {currentServiceData.prices.map((p) => (
                    <option key={p.label} value={p.label}>{p.label} — {p.price}</option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* COLONNE DROITE */}
          <div className="modal-right">
            <h3  className="modal-subtitle"id="modaltitle2" >Votre projet</h3>
            <form onSubmit={handleSubmit} className="modal-form">
              <textarea
                required
                placeholder="Décrivez votre projet en quelques lignes (objectif, délai, budget estimé…)"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <button type="submit" className="btn btn-primary btn-lg" disabled={sending}>
                {sending ? "Envoi..." : "Envoyer ma demande"}
              </button>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
